import React, { useState, useCallback, useMemo, useContext } from 'react';
import usePositions from '@ubeya/shared/hooks/account/usePositions';
import { filterPositionOptionsByBranchId } from '../../../utils/positions';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const PositionsFilter = ({
  defaultValue,
  handleClose,
  onApply,
  search,
  onChange,
  hideLayout = false,
  filterContextParams
}) => {
  const { t } = useContext(ConfigContext);
  const { positionsOptions, mappedPositions } = usePositions();
  const branchId = filterContextParams?.branchId;

  const branchFilteredOptions = useMemo(
    () => filterPositionOptionsByBranchId({ positionsOptions, mappedPositions, branchId }),
    [positionsOptions, mappedPositions, branchId]
  );

  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      search
        ? branchFilteredOptions.filter(
            ({ label }) =>
              t('positions').toLowerCase().includes(search.toLowerCase()) ||
              label.toLowerCase().includes(search.toLowerCase())
          )
        : branchFilteredOptions,
    [branchFilteredOptions, search, t]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('positions')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`position-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default PositionsFilter;
